import { combineReducers } from "redux";
import SearchReducer from "./Search/SearchReducer";

const dataReducers = {
    SearchResults: SearchReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);

export default dataReducer;
